type WebsocketResponse = {
    statusCode?: number;
    body?: string;
    message?: string;
    [key: string]: unknown;
};

export function sendAndWaitForResponse<T = unknown>(
    socket: WebSocket,
    payload: object,
    expectedAction: string,
    timeout = 5000,
): Promise<T> {
    return new Promise((resolve, reject) => {
        let timer: ReturnType<typeof setTimeout>;
        const handleMessage = (event: MessageEvent) => {
            try {
                const data: WebsocketResponse = JSON.parse(event.data);

                // Server-side error (no body field, e.g. API Gateway error)
                if (!data.body && data.message) {
                    socket.removeEventListener('message', handleMessage);
                    clearTimeout(timer);
                    reject(new Error(data.message));
                    return;
                }

                if (!data.body) {
                    return;
                }

                const bodyPayload = JSON.parse(data.body);

                // Only resolve when the response action matches what we sent
                if (bodyPayload.action?.toLowerCase() === expectedAction.toLowerCase()) {
                    socket.removeEventListener('message', handleMessage);
                    clearTimeout(timer);
                    resolve(data as T);
                }
            } catch (e) {
                console.error('[WS] Error parsing message', e);
            }
        };

        timer = setTimeout(() => {
            socket.removeEventListener('message', handleMessage);
            reject(new Error(`Timeout while waiting for "${expectedAction}" response.`));
        }, timeout);

        socket.addEventListener('message', handleMessage);
        socket.send(JSON.stringify(payload));
    });
}
